var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({attrs:{"fab":"","color":_vm.color,"small":_vm.small},on:{"click":function($event){return _setup.emit('clicked', $event)}}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"small":_vm.small}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }